export default function convertDate(date) {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  let rawDate = date;
  if (date.includes("+00:00")) {
    rawDate = date.replace("+00:00", "");
  }
  const utcDate = `${rawDate}Z`;
  const newDate = new Date(utcDate);
  const newDateString = newDate.toLocaleString("en-US", options);
  return newDateString;
}
